let gorgiasChatInterval = window.setInterval(function () {
  let iframe = document.querySelector('#chat-button');
  const gorgiasChatContainer = document.getElementById('gorgias-chat-container');

  if (iframe) {
    const iframeDoc = iframe.contentWindow.document;
    let frameRoot = iframe.contentWindow.document.querySelector('.frame-root');
    let span = document.createElement('div');
    span.className = 'tooltip';
    span.textContent = 'Live Chat';
    iframe.style.cssText = "width: 70px; height: 70px;bottom:20px;";
    let head = iframe.contentWindow.document.querySelector('head');
    const buttonContainer = iframeDoc.getElementById('gorgias-chat-messenger-button');
    if (buttonContainer) {
      buttonContainer.style = 'background:#4E469D;box-shadow:none;width:60px;height:60px;';
      buttonContainer.children[0].children[0].children[0].style = 'fill: #fff;'
      const messagerButtonContainer = buttonContainer.children[1];
      messagerButtonContainer.style = 'height: 100%;width: 100%;display: flex;align-items: center;text-align: center;';
      const messagerContainer = buttonContainer.children[1].children[0];
      messagerContainer.style = 'height: auto;width: auto;color:#fff;';
      messagerContainer.innerText = 'Need Help?'
      gorgiasChatContainer.style.display = 'block';
      if (head.children.length) {
        window.clearInterval(gorgiasChatInterval); // this line breaks out of the loop - make sure it's not deleted.
        let styles = document.createElement('style');
        styles.textContent = '.messenger-button-shown .tooltip {font-weight: bold; font-size: 15px; visibility: hidden; transition: opacity 0.3s; position: absolute; white-space: nowrap; top: -42%; left: 50%; transform: translate(-50%, 0); opacity: 0; transition: opacity 1s;} .messenger-button-shown:hover .tooltip {visibility: visible;  opacity: 1;}';
        head.appendChild(styles)
      }
    }
  }
}, 1000);